import {connect} from 'react-redux';
import TurboCashSimulatorView from '../../../components/views/mx/creditoReal/TurboCashSimulatorView';
import * as CalculatorActions from '../../../actions/CalculatorActions';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as WizardValidationUtils from '../../../utils/WizardValidationUtils';
import {withRouter} from 'react-router';
import {FormFieldProps} from '../../../../common/types/components';
import {MX_VALUES} from '../../../constants/MX/WizardInputs';
import {BankTarget} from '../../../types/mx/types';
import {CatalogsHeadlessGraphCms} from '../../../types/mx/catalog';
import {CommonCalculatorConfig} from '../../../types/mx/components';
import {MODAL_TYPE} from '../../../constants/ModalConstants';
import * as ModalActions from '../../../actions/ModalActions';
import {isWebDevice} from '../../../utils/ValidationUtils';

const mapStateToProps = (state, {match}) => {
    const calculatorStepViewState = state.turboCash.ui.calculatorStepView.fieldErrors;
    const {turboCash: {calculator}, countrySelector, catalogs} = state;
    const globalValidations: CommonCalculatorConfig = state.globalValidations.turboCash;
    const quotas = calculator.quotas && calculator.quotas.length > 0 ? calculator.quotas[0] : {};
    const isTurboCashSimulator: boolean = state.turboCash.calculator.bank === BankTarget.TURBO_CASH;
    let currentStep: number = state.turboCash.loanApplication.highestStep;
    currentStep = currentStep > 0 && currentStep < 7 ? currentStep : 1;
    const provinceSelected = state.turboCash.loanApplication.applicantHome.state;
    const provinceFieldError = state.turboCash.ui.homeDataStepView.stateFieldError;

    const existModel = !!catalogs.models.find(m => m.id === catalogs.modelSelected.id);
    const existVersion = !!catalogs.versions.find(v => v.id === catalogs.versionSelected.id);

    const catalogsGCms: CatalogsHeadlessGraphCms = state.catalogs.headlessGraphCms;
    const hasOffer: boolean = !!catalogsGCms.offers.find(item => isWebDevice(item.source));

    return {
        hasOffer,
        calculator,
        catalogs,
        isTurboCashSimulator,
        currentStep,
        provinces: catalogs.provinces,
        years: catalogs.years,
        brands: catalogs.brands,
        models: existModel ? catalogs.models : !!catalogs.modelSelected &&
        !!catalogs.modelSelected.id ? [catalogs.modelSelected] : [],
        versions: existVersion ? catalogs.versions : !!catalogs.versionSelected &&
        !!catalogs.versionSelected.id ? [catalogs.versionSelected] : [],
        country: countrySelector.countrySelected,
        minPrice: globalValidations.minAllowedVehiclePrice,
        minDownPayment: globalValidations.minDownPayment,
        minDownPaymentValue: (calculator.price >= globalValidations.minAllowedVehiclePrice ? calculator.price :
            globalValidations.minAllowedVehiclePrice) * globalValidations.minDownPayment,
        maxDownPayment: globalValidations.maxDownPayment,

        yearSelectedField: new FormFieldProps(
            calculator.yearSelected, calculatorStepViewState.yearFieldError),
        brandSelectedField: new FormFieldProps(
            calculator.brandSelected, calculatorStepViewState.brandFieldError),
        modelSelectedField: new FormFieldProps(
            calculator.modelSelected, calculatorStepViewState.modelFieldError),
        versionSelectedField: new FormFieldProps(
            calculator.versionSelected, calculatorStepViewState.versionFieldError),
        provinceSelectedField: new FormFieldProps(
            provinceSelected, provinceFieldError),
        priceField: new FormFieldProps(
            calculator.price, calculatorStepViewState.priceFieldError),
        downPaymentField: new FormFieldProps(
            calculator.downPayment, calculatorStepViewState.downPaymentFieldError),
        monthlyPaymentField: new FormFieldProps(
            calculator.monthlyPayment, calculatorStepViewState.monthlyPaymentFieldError),
        hasCalculatorFieldsError: WizardValidationUtils.hasCalculatorFieldsError(
            calculatorStepViewState.yearFieldError,
            calculatorStepViewState.brandFieldError,
            calculatorStepViewState.modelFieldError,
            calculatorStepViewState.versionFieldError,
            calculatorStepViewState.provinceFieldError,
            calculatorStepViewState.priceFieldError,
            calculatorStepViewState.downPaymentFieldError,
            calculatorStepViewState.monthlyPaymentFieldError,
            null
        ),

        insuranceIncludesOptions: [{
            id: '1',
            value: true,
            label: 'Deseo incluir el seguro vehicular en el financiamiento',
            defaultChecked: calculator.hasInsurance
        }, {
            id: '2',
            value: false,
            label: 'Deseo pagar mi seguro vehicular de contado',
            defaultChecked: !calculator.hasInsurance
        }],

        hasQuotas: calculator.quotas.length > 0,
        insuranceAmount: quotas.insuranceAmount,
        financingAmount: quotas.financingAmount,
        commissionAmount: quotas.commissionAmount,
        quotasDescription: quotas.description,
        monthlyPayments: quotas.monthlyPayments,

        hasInsurance: calculator.hasInsurance,
        failInsurance: calculator.failInsurance,
        isInsuranceInFinancing: calculator.hasInsurance && !calculator.failInsurance,
        defaultMonthlyPayment: MX_VALUES.MONTHLY_PAYMENTS
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeYear: (year, error) =>
            dispatch(CalculatorActions.YEAR_SELECTED_ACTION.action(year, error)),
        onChangeBrand: (brand, error) =>
            dispatch(CalculatorActions.BRAND_SELECTED_ACTION.action(brand, error)),
        onChangeModel: (model, error) =>
            dispatch(CalculatorActions.MODEL_SELECTED_ACTION.action(model, error)),
        onChangeVersion: (version, error) =>
            dispatch(CalculatorActions.VERSION_SELECTED_ACTION.action(version, error)),
        onChangeState: (province, error) =>
            dispatch(CalculatorActions.PROVINCE_SELECTED_ACTION.action(province, error)),
        onChangePrice: (price, error) =>
            dispatch(CalculatorActions.CHANGE_PRICE_ACTION.action(price, error)),
        onChangeDownPayment: (downPayment, error) =>
            dispatch(CalculatorActions.CHANGE_DOWN_PAYMENT_ACTION.action(downPayment, error)),
        onChangeIncludeInsurance: includeInsurance =>
            dispatch(CalculatorActions.HAS_INSURANCE_SELECTED_ACTION.action(includeInsurance.value)),
        onChangeMonthlyPayment: (monthlyPayment, error) =>
            dispatch(CalculatorActions.MONTHLY_PAYMENT_SELECTED_ACTION.action(monthlyPayment, error)),
        onPressAcceptQuote: () => {
            dispatch(WizardMXActions.SAVE_TURBO_CASH_CALCULATOR_DATA_MX_ACTION.action(true));
        },
        getLoanApplication: (isTurboCashSimulator: boolean, currentStep: number) => () => {
            if (!isTurboCashSimulator) dispatch(WizardMXActions.SET_RETURN_TO_SUMMARY.action(currentStep));
            else dispatch(WizardMXActions.ON_LOAD_TURBO_CASH_SIMULATOR_MX_ACTION.action());
        },
        onPressNoAcceptQuote: (hasOffer: boolean) => () => {
            if (hasOffer) {
                const content = {
                    type: MODAL_TYPE.TURBO_CASH_OFFER_VIEW
                };
                const options = {
                    closeOnOverlayClick: false
                };
                dispatch(ModalActions.OPEN_MODAL_DATA_ACTION.action(null, content, null, options));
            } else {
                dispatch(WizardMXActions.SAVE_TURBO_CASH_CALCULATOR_DATA_MX_ACTION.action(false));
            }
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    const {monthlyPayments, monthlyPaymentField, isTurboCashSimulator, currentStep, hasOffer} = stateProps;
    return {
        ...stateProps,
        ...dispatchProps,
        getLoanApplication: dispatchProps.getLoanApplication(isTurboCashSimulator, currentStep),
        onPressNoAcceptQuote: dispatchProps.onPressNoAcceptQuote(hasOffer),
        monthlyPayments: monthlyPayments ?
            monthlyPayments.map(item => ({...item, defaultChecked: monthlyPaymentField.value.id === item.id})) :
            monthlyPayments
    };
};

const TurboCashSimulatorContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(TurboCashSimulatorView));

export default TurboCashSimulatorContainer;
